var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 388.543,
    y: 170.489,
    style: {
      fill: "#E6EAEA"
    },
    width: 102.614,
    height: 188.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.543,
    y: 307.307,
    style: {
      fill: "#687F82"
    },
    width: 102.614,
    height: 51.307
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M448.401,340.977h-17.102c-4.427,0-8.017-3.588-8.017-8.017c0-4.428,3.589-8.017,8.017-8.017h17.102 c4.427,0,8.017,3.588,8.017,8.017C456.418,337.389,452.828,340.977,448.401,340.977z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.946,
    y: 256,
    style: {
      fill: "#E6EAEA"
    },
    width: 290.739,
    height: 247.983
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.843,
    y: 469.779,
    style: {
      fill: "#FD6A33"
    },
    width: 324.944,
    height: 34.205
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.599,
    y: 8.017,
    style: {
      fill: "#E6EAEA"
    },
    width: 256.534,
    height: 188.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.827,
    y: 8.017,
    style: {
      fill: "#4ACFD9"
    },
    width: 51.307,
    height: 188.125
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0295AA"
    },
    d: "M294.48,118.647c-4.427,0-8.017-3.588-8.017-8.017V84.977c0-4.428,3.589-8.017,8.017-8.017 c4.427,0,8.017,3.588,8.017,8.017v25.653C302.497,115.059,298.908,118.647,294.48,118.647z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M491.157,162.472h-45.579c-13.228-20.102-30.817-37.459-51.105-50.378c-20.034-12.757-42.828-21.224-66.323-24.716V8.017 c0-4.428-3.589-8.017-8.017-8.017h-51.307H63.599c-4.427,0-8.017,3.588-8.017,8.017v188.125c0,4.428,3.589,8.017,8.017,8.017h76.982 c-4.53,14.18-7.162,28.853-7.852,43.825H37.946c-4.427,0-8.017,3.588-8.017,8.017v205.762h-9.086c-4.427,0-8.017,3.588-8.017,8.017 v34.205c0,4.428,3.589,8.017,8.017,8.017h17.102h290.739h17.102c4.427,0,8.017-3.588,8.017-8.017v-34.205 c0-4.428-3.589-8.017-8.017-8.017h-9.086v-38.617c37.367-7.488,71.139-27.334,96.041-56.515h58.414c4.427,0,8.017-3.588,8.017-8.017 v-51.307V170.489C499.173,166.06,495.584,162.472,491.157,162.472z M483.14,299.29h-86.58V178.505h44.624 c0.005,0,0.011,0.001,0.017,0.001c0.005,0,0.011-0.001,0.015-0.001h41.924V299.29z M425.913,162.472h-37.371 c-4.427,0-8.017,3.588-8.017,8.017v136.818v51.307c0,4.428,3.589,8.017,8.017,8.017h22.267 c-20.521,20.013-46.14,33.911-74.109,40.127V256c0-4.428-3.589-8.017-8.017-8.017H148.786c0.765-15.029,3.692-29.717,8.723-43.825 h111.318h51.307c4.427,0,8.017-3.588,8.017-8.017v-92.551C366.808,109.977,402.073,131.296,425.913,162.472z M312.117,94.395 c0,0.01,0,0.019,0,0.029v93.701h-35.273V97.147V16.033h35.273V94.395z M71.616,16.033H260.81v81.114v90.978H151.952H71.616V16.033z  M140.56,264.017h180.109v152.432v45.314H45.962V264.017H140.56z M337.77,495.967h-9.086H37.946H28.86v-18.171h9.086h290.739h9.086 V495.967z M428.993,350.597H396.56v-35.273h86.58v35.273H428.993z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.5a0597aa922e275beea52b5e614cb194.svg";
export { ForwardRef as ReactComponent };